import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDashboardService } from "services/DashboardService";
import { DailyItineraryItemModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  DailyItinerary: new Array<DailyItineraryItemModel>(),
  LoadingDailyItinerary: false,
};

export const DailyItinerarySlice = createSlice({
  name: "dailyItinerary",
  initialState,
  reducers: {
    setDailyItinerary: (state, action) => {
      state.DailyItinerary = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDailyItinerary.pending, (state) => {
        state.LoadingDailyItinerary = true;
      })
      .addCase(getDailyItinerary.fulfilled, (state, action) => {
        state.DailyItinerary = action.payload;
        state.LoadingDailyItinerary = false;
      })
      .addCase(getDailyItinerary.rejected, (state) => {
        state.LoadingDailyItinerary = false;
      });
  },
});

export const getDailyItinerary = createAsyncThunk("dailyItinerary/GetDailyItinerary", async () => {
  const dashboardService = container.get<IDashboardService>(SERVICE_TYPES.DashboardService);
  return await dashboardService.getDailyItinerary();
});

export const selectDailyItinerary = (state: RootState) => {
  return state.dailyItinerary.DailyItinerary;
};

export const selectLoadingDailyItinerary = (state: RootState) => {
  return state.dailyItinerary.LoadingDailyItinerary;
};

export default DailyItinerarySlice.reducer;
